/**
 * Where a session opens when a link names it: its report once it is done,
 * the Event Designer for a v3 event, its room when it runs live, otherwise
 * its detail page. One rule, shared by the sessions list and the Tools hub.
 */
import type { PrioritizationSession } from '../../types/prioritization/session';

export function sessionDetailUrl(session: PrioritizationSession): string {
  const isTerminal = session.state === 'RUN_COMPLETE' || session.state === 'PUBLISHED';
  const isLive = session.modeConfig?.timingMode === 'live';
  const isV3 = !!(session.modeConfig as unknown as Record<string, unknown> | undefined)?.v3Config;

  if (isTerminal) {
    return `/prioritization/reports/session/${session.id}`;
  }
  // V3 events → back to the Event Designer with this session pre-loaded
  if (isV3) {
    return `/prioritization/sessions/explore?resume=${session.id}`;
  }
  if (isLive) {
    return `/prioritization/sessions/${session.id}/live`;
  }
  return `/prioritization/sessions/${session.id}`;
}

